import React, { useEffect, useState } from 'react'
import { Checkbox, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow,} from '@mui/material'
import { columnDefs } from '../constants'
import FilterAltIcon from '@mui/icons-material/FilterAlt'
import EditIcon from '@mui/icons-material/Edit'
import TableCellTooltip from '../../../common/TableCellTooltip'
import { connect } from 'react-redux'
import CreateNewUser from './CreateNewUser'
import { getEditUser } from '../../../../store/branchAndUserMaster/BUMAction'
import { focusElemnt, navigation3 } from '../../../common/helper'
import { alertAtom, modalAtom } from '../../../common/jotaiState/globalStateAtoms'
import { useAtom } from 'jotai'
import QRDownloadIcon from '../../../../assests/QRDownloadIcon.png'
import jsPDF from "jspdf";
import QRCode from "qrcode";
import {encrypt } from '../../../common/loginDecode'
const UserMasterTable = (props) => {

    const { data, tableData, getEditUser, rollRightData, branchData, onLoad,status,loginData } = props
    const { common } = data
    const [modal, setModal] = useAtom(modalAtom)
    const [, setAlert] = useAtom(alertAtom)
    const [showTableData, setShowTableData] = useState(tableData)
    const [editUserData, setEditUserData] = useState({ data: "", id: "" })
    const [searchData, setSearchData] = useState({
        CompanyName: "", BranchName: "", BranchCode: "", Statename: "",
        CityName: "", UserID: "", UserName: "", ContactNo: "", RoleName: "",
        CrewType: "", CrewName: ""
    })
    useEffect(() => {
        let fiterData = tableData?.filter((val) =>
            (searchData.CompanyName === "" || val.CompanyName.toString().includes(searchData.CompanyName.toString())) &&
            (searchData.BranchName === "" || val.BranchName.toLowerCase().includes(searchData.BranchName.toLowerCase())) &&
            (searchData.BranchCode === "" || val.BranchCode.toLowerCase().includes(searchData.BranchCode.toLowerCase())) &&
            (searchData.Statename === "" || val.Statename.toLowerCase().includes(searchData.Statename.toLowerCase())) &&
            (searchData.CityName === "" || val.CityName.toLowerCase().includes(searchData.CityName.toLowerCase())) &&
            (searchData.UserID === "" || val.UserID.toString().includes(searchData.UserID.toString())) &&
            (searchData.UserName === "" || val.UserName.toLowerCase().includes(searchData.UserName.toLowerCase())) &&
            (searchData.ContactNo === "" || val.ContactNo.toString().includes(searchData.ContactNo.toString())) &&
            (searchData.RoleName === "" || val.RoleName.toLowerCase().includes(searchData.RoleName.toLowerCase())) &&
            (searchData.CrewType === "" || val.CrewType.toLowerCase().includes(searchData.CrewType.toLowerCase())) &&
            (searchData.CrewName === "" || val.CrewName.toLowerCase().includes(searchData.CrewName.toLowerCase())))
        setShowTableData(fiterData)
    }, [searchData])
    useEffect(() => {
        if (tableData?.length > 0) {
            if(status?.id===-1){
                setShowTableData(tableData.sort((a,b)=>b.IsActive-a.IsActive))
            }else{
                setShowTableData(tableData)
            }
        } else {
            setShowTableData([])
        }
        setSearchData({
            CompanyName: "", BranchName: "", BranchCode: "", Statename: "",
            CityName: "", UserID: "", UserName: "", ContactNo: "", RoleName: "",
            CrewType: "", CrewName: ""
        })
    }, [tableData])

    const EditUserModal = () => {
        return <CreateNewUser onLoad={onLoad} isEdit={true} editUserData={editUserData} rollRightData={rollRightData} branchData={branchData || []}  />
    }
    const editClick = (item) => {
        const obj = {
            CompanyID: loginData?.intCompanyID,
            BranchID: item?.BranchID,
            UserID: item.UserID
        }
        getEditUser(obj).then((res) => {
            if (res?.status == 'Success') {
                if (res?.Data?.Table?.length > 0) {
                    setEditUserData({ ...editUserData, data: res?.Data?.Table[0], id: item.UserID, IsFocApprovalAuth: item.IsFocApprovalAuth})
                    setModal("UpdateUseMaster")
                } else {
                    setEditUserData({ ...editUserData, data: "", id: "" })
                    setModal("UpdateUseMaster")
                }
            } else {
                setEditUserData({ ...editUserData, data: "", id: "" })
                setAlert({ show: true, msg: res.ErrMessage, nextId: '' })
            }
        }).catch((err) => {
            console.log("Error:", err)
        })

    }
    const keyboardNavigation = (event, prevId, nextId) => {
        if (event.key === 'Escape') {
            focusElemnt(prevId)
        }
        if (event.key === 'Enter') {
            focusElemnt(nextId)
        }
    }
    const handleDownloadQR = async (item) => {
        try {
            const qrString = `${item.UserID}^^^^${item.BranchID}^^^^${item.UserName}^^^^${item.CrewType}`;
            const updateQRString=encrypt(qrString)
            const qrDataUrl = await QRCode.toDataURL(updateQRString, { width: 200 });
            const pdf = new jsPDF();
            pdf.setFontSize(14);
            pdf.text(`User QR Code `, 30, 20);
            pdf.text(`${item.UserName}`, 30, 30);
            pdf.addImage(qrDataUrl, "PNG", 20, 35, 100, 100);
            pdf.save(`QR_${item.UserName}.pdf`);
        } catch (err) {
            console.error("QR generation failed:", err);
        }
    };
    const InsideRowContent = ({ item, index }) => {
        return (
            <TableRow key={`DR-${index}`}>
                <TableCell style={{ height: '36px', textAlign: 'right', fontSize: '12px', color: '#666', }}>{index + 1}</TableCell>
                <TableCellTooltip title={item?.CompanyName || ""} data={item?.CompanyName || ""} placement="bottom-start" textAlign="left" maxWidth="140px" />
                <TableCellTooltip title={item?.BranchName || ""} data={item?.BranchName || ""} placement="bottom-start" textAlign="left" maxWidth="140px" />
                <TableCell style={{ height: '36px', textAlign: 'left', fontSize: '12px', color: '#666', }}>{item.BranchCode}</TableCell>
                <TableCellTooltip title={item?.Statename || ""} data={item?.Statename || ""} placement="bottom-start" textAlign="left" maxWidth="108px" />
                <TableCell style={{ height: '36px', textAlign: 'left', fontSize: '12px', color: '#666', }}>{item.CityName}</TableCell>
                <TableCell style={{ height: '36px', textAlign: 'left', fontSize: '12px', color: '#666', }}>{item.UserID}</TableCell>
                <TableCellTooltip title={item?.UserName || ""} data={item?.UserName || ""} placement="bottom-start" textAlign="left" maxWidth="100px" />
                <TableCell style={{ height: '36px', textAlign: 'left', fontSize: '12px', color: '#666', }}>{item.ContactNo}</TableCell>
                <TableCell style={{ height: '36px', textAlign: 'left', fontSize: '12px', color: '#666', }}>{item.RoleName}</TableCell>
                <TableCell style={{ height: '36px', textAlign: 'left', fontSize: '12px', color: '#666', }}>{item.CrewType}</TableCell>
                <TableCell style={{ height: '36px', textAlign: 'left', fontSize: '12px', color: '#666', }}>{item.CrewName}</TableCell>
                <TableCell style={{ height: '36px', textAlign: 'left', fontSize: '12px', color: '#666' }}>
                    <Checkbox
                        checked={item.IsActive === 1}
                        sx={{ padding: "0", borderRadius: "0" }}
                    />
                </TableCell>
                <TableCell style={{ height: '36px', textAlign: 'left', fontSize: '12px', color: '#666', cursor: "pointer" }}>
                    <span
                        id={`Edit-${index}`} tabIndex={0}
                        style={{ display: 'flex', color: '#007bfd', fontSize: '13px', fontWeight: 'bold' }}
                        onClick={() => editClick(item)}
                        onKeyDown={(e) => navigation3(e, showTableData.length === index + 1 ? "Contains-1" : `Edit-${index + 1}`, index === 0 ? `Contains-11` : `Edit-${index - 1}`, () =>   editClick(item))}
                    >
                        <EditIcon sx={{ marginRight: '3px' }} />
                        Edit
                    </span>
                </TableCell>
                <TableCell style={{ height: '36px', textAlign: 'left', fontSize: '12px', color: '#666', cursor: "pointer" }}>
                    <span
                        id={`Edit-${index}`} tabIndex={0}
                        style={{ display: 'flex', color: '#007bfd', fontSize: '13px', fontWeight: 'bold' }}
                        onClick={() => handleDownloadQR(item)}
                        // onKeyDown={(e) => navigation3(e, showTableData.length === index + 1 ? "Contains-1" : `Edit-${index + 1}`, index === 0 ? `Contains-11` : `Edit-${index - 1}`, () =>   editClick(item))}
                    >
                    <img src={QRDownloadIcon} alt="QR" style={{height: '25px', width: '68px'}} />
                    </span>
                </TableCell>
            </TableRow>
        )
    }

    const handleSearchData = (event, field) => {
        setSearchData({ ...searchData, [field]: event.target.value })
    }

    return (
        <>
            <TableContainer component={Paper} className='scrollBlue' style={{ maxHeight: '70vh', marginBottom: "5px" }} >
                <Table stickyHeader size="small" aria-label="a dense table" sx={{
                    '& .MuiTableCell-root': {
                        padding: '6px !important'
                    }
                }}>
                    <TableHead style={{ position: `sticky`, top: `0`, zIndex: "2" }}>
                        <TableRow>
                            {columnDefs.map((col, index) =>
                                <TableCell key={`TH-${index}`} style={{ ...col.headerSx, backgroundColor: '#DAEDFE', height: '36px', fontSize: '12px', fontWeight: '600', color: '#444' }}>{col.headerName}</TableCell>
                            )}
                        </TableRow>
                        <TableRow>
                            {columnDefs.map((col, index) => col.showfilter ?
                                <TableCell key={`FTH-${index}`}>
                                    <div className="filter-input" style={{ fontSize: '12px', justifyContent: 'space-between' }}>
                                        <input
                                            id={`Contains-${index}`}
                                            className="field"
                                            name="cancelSearchInput"
                                            style={{ width: '100%', height: "24px" }}
                                            placeholder="Contains"
                                            autoComplete="off"
                                            value={searchData[col.field]}
                                            onChange={(e) => handleSearchData(e, col.field)}
                                            onKeyDown={(e) => keyboardNavigation(e, index === 1 ? "UMCreateNewMaster" : `Contains-${index - 1}`, index === 11 ? `Edit-0` : `Contains-${index + 1}`)}
                                        // onKeyDown={(e) => navigation2(e, `index-${index - 1}`,`index-${index + 1}`)}
                                        // onKeyDown={(e) => keyboardNavigation(e, index === 1 ? `Edit-${showTableData?.length - 1}` : `index-${index - 1}`, index === 10 ? 'Edit-0' : `index-${index + 1}`)}
                                        />
                                        <FilterAltIcon style={{ color: "#aaa" }} />
                                    </div>
                                </TableCell>
                                : <TableCell></TableCell>)}
                        </TableRow>
                    </TableHead>
                    {showTableData?.length <= 0 ? (
                        <>
                            <TableBody>
                                <TableRow>
                                    <TableCell colSpan={14}>
                                        <div
                                            style={{
                                                display: 'flex',
                                                justifyContent: 'center',
                                                marginTop: '20px',
                                                marginBottom: '20px',
                                                color: 'red',
                                                fontSize: '14px',
                                            }}
                                        >
                                            <span>No results found. Please refine your search parameters and search again.</span>
                                        </div>
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        </>
                    ) : showTableData.length > 0 ? (
                        <TableBody className="filter-data-row-BorderNone" sx={{ border: "none !important" }}>
                            {showTableData?.map((item, index) => (
                                <InsideRowContent item={item} index={index} key={index} />
                            ))}
                        </TableBody>
                    ) : (
                        ''
                    )}
                </Table>
            </TableContainer>
            {modal === "UpdateUseMaster" && EditUserModal()}
        </>
    )
}
const mapStateToProps = (data) => ({ data })
const mapDispatchToProps = { getEditUser}
export default connect(mapStateToProps, mapDispatchToProps)(UserMasterTable)
